export const VISIT_REQUEST_APPROVED = 'VISIT_REQUEST_APPROVED';
export const VISIT_REQUEST_DECLINED = 'VISIT_REQUEST_DECLINED';
export const VISIT_RESCHEDULED = 'VISIT_RESCHEDULED';
export const VISIT_CANCELLED = 'VISIT_CANCELLED';
export const VISIT_MANUALLY_SCHEDULED = 'VISIT_MANUALLY_SCHEDULED';
export const VISIT_REASSIGNED = 'VISIT_REASSIGNED';

export const FAIR_REQUEST_APPROVED = 'FAIR_REQUEST_APPROVED';
export const FAIR_REQUEST_DECLINED = 'FAIR_REQUEST_DECLINED';
export const FAIR_RESCHEDULED = 'FAIR_RESCHEDULED';
export const FAIR_CANCELLED = 'FAIR_CANCELLED';
export const FAIR_ATTENDEE_CANCELLED = 'FAIR_ATTENDEE_CANCELLED';
export const FAIR_REASSIGNED = 'FAIR_REASSIGNED';

export const VISIT_TYPE_CHANGED_TO_IN_PERSON = 'VISIT_TYPE_CHANGED_TO_IN_PERSON';
export const VISIT_TYPE_CHANGED_TO_VIRTUAL = 'VISIT_TYPE_CHANGED_TO_VIRTUAL';

export const defaultNotificationTypes = [
  VISIT_REQUEST_APPROVED,
  VISIT_REQUEST_DECLINED,
  VISIT_RESCHEDULED,
  VISIT_CANCELLED,
  VISIT_MANUALLY_SCHEDULED,
  VISIT_REASSIGNED,
  FAIR_REQUEST_APPROVED,
  FAIR_REQUEST_DECLINED,
  FAIR_RESCHEDULED,
  FAIR_CANCELLED,
  FAIR_ATTENDEE_CANCELLED,
  FAIR_REASSIGNED,
];

export const virtualNotificationTypes = [
  VISIT_TYPE_CHANGED_TO_IN_PERSON,
  VISIT_TYPE_CHANGED_TO_VIRTUAL,
];
